import React from 'react'

import { Typography } from '~/components/elements/Typography'
import { VStack } from '~/components/elements/VStack'

import styles from './DataSettingsCardSection.css'

export type DataSettingsCardSectionProps = React.PropsWithChildren<{
  title: string
}>

export const DataSettingsCardSection = ({
  children,
  title,
}: DataSettingsCardSectionProps) => (
  <VStack className={styles.root} spacing={4}>
    <Typography variant="heading3">{title}</Typography>

    {children}
  </VStack>
)
